import React from 'react'
import { Row, Col } from 'antd';
import Img1 from '../images/seller-1.png'
import Img2 from '../images/seller-2.png'
import Img3 from '../images/seller-3.png'
import Img4 from '../images/seller-4.png'
import Img5 from '../images/seller-center.png'


function Sellers() {
    return (
        <div>
            <section className='seller'>
                <div className="container">
                    <h2>Best Sellers </h2>
                    <Row gutter={(0, 0)} align={"middle"} justify="center">

                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                            <div className="seller-dev">
                                <ul>
                                    <li><a href="/category/saying-quotes">
                                        <img className='rounded' src={Img1} alt="Accept Trilogy letter artwork" />
                                        <h3>Accept Trilogy</h3>
                                    </a></li>
                                    <li><a href="/category/saying-quotes">
                                        <img className='rounded' src={Img2} alt="Live Laugh Love letter artwork" />
                                        <h3>Live Laugh Love</h3>
                                    </a></li>
                                </ul>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                            <div className="seller-dev">
                                <ul>
                                    <li>
                                        <a href="/category/multi-lines-stacks">
                                            <img className='rounded' src={Img5} alt="Together We Make a Family letter artwork" />
                                            <h3>Together We Make a Family</h3>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                            <div className="seller-dev">
                                <ul>
                                    <li><a href="/category/ready-made-words">
                                        <img className='rounded' src={Img3} alt="Blessed 1 letter artwork" />
                                        <h3>Blessed 1</h3>
                                    </a></li>
                                    <li><a href="/category/ready-made-words">
                                        <img className='rounded' src={Img4} alt="Family 1 letter artwork" />
                                        <h3>Family 1</h3>
                                    </a></li>

                                </ul>
                            </div>

                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    )
}

export default Sellers
